<template>
  <div>
    <div class="summary-header">
      <div class="summary-title">
        <div class="new-request-icon-material-request"></div>
        <div class="summary-text">
          {{ $t('newRequest') }}
        </div>
      </div>
    </div>
    <div class="input-full">
      <div>
        <div class="card-content padding">
          <div class="form-container">
            <form>
              <DxForm
                label-location="top"
                :form-data="formData"
                :col-count="3"
              >
                <DxGroupItem :col-count="2" :col-span="3">
                  <DxItem
                    :editor-options="{
                      dataSource: store,
                      displayExpr: 'CodPresupuestoTitulo',
                      valueExpr: 'CodPresupuesto',
                    }"
                    :is-required="true"
                    data-field="CodPresupuesto"
                    editor-type="dxSelectBox"
                  >
                    <DxLabel :text="$t('offers')" />
                  </DxItem>
                  <DxItem
                    data-field="deliveryType"
                    editor-type="dxSelectBox"
                    :editor-options="{
                      dataSource: deliverytype,
                      displayExpr: 'label',
                      valueExpr: 'id',
                    }"
                    :is-required="true"
                  >
                    <DxLabel :text="$t('deliveryType')" />
                  </DxItem>
                  <DxItem
                    data-field="addresses"
                    editor-type="dxSelectBox"
                    css-class="help-on-hover"
                    :help-text="$t('addressesShown')"
                    :editor-options="{
                      dataSource: contactInfo.adressesCity,
                      displayExpr: 'name',
                      valueExpr: 'addressCode',
                      disabled: adressesDisabled,
                      acceptCustomValue: false,
                      onCustomItemCreating(e) {
                        const newItem = {
                          name: e.text,
                          addressCode: e.text,
                        };
                        contactInfo.adressesCity.push(newItem);
                        e.customItem = newItem;
                      },
                    }"
                    :is-required="true"
                  >
                    <DxLabel :text="$t('addresses')" />
                  </DxItem>

                  <DxItem
                    data-field="Referencia"
                    editor-type="dxTextBox"
                  >
                    <DxLabel :text="$t('RequestReference')" />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem
                  :col-count="2"
                  :col-span="2"
                  :visible="!ContactSelect"
                >
                  <DxItem
                    data-field="Email"
                    editor-type="dxTextBox"
                    :editor-options="{
                      value: authenticatedUser.email,
                      readOnly: true,
                      stylingMode: 'outlined',
                      elementAttr: { class: 'dotted-field' },
                    }"
                  >
                    <DxLabel :text="$t('receiver')" />
                  </DxItem>
                  <DxItem
                    data-field="phone"
                    editor-type="dxTextBox"
                    css-class="form-item-right"
                    :editor-options="{
                      value:
                        authenticatedUser.contacts[0].phone[0].number,
                      readOnly: true,
                      stylingMode: 'outlined',
                      elementAttr: { class: 'dotted-field' },
                    }"
                  >
                    <DxLabel :text="$t('phone')" />
                  </DxItem>
                </DxGroupItem>

                <DxGroupItem
                  :col-count="1"
                  :col-span="1"
                  :visible="ContactSelect"
                >
                  <DxItem
                    data-field="personaContacto"
                    editor-type="dxSelectBox"
                    :editor-options="{
                      dataSource: usersInfo,
                      displayExpr: 'email',
                      valueExpr: 'contactCode',
                      visible: true,
                    }"
                  >
                    <DxLabel :text="$t('receiver')" :visible="true" />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem :col-count="1" :col-span="2">
                  <DxItem
                    data-field="SelectContactCheck"
                    editor-type="dxCheckBox"
                    :col-span="2"
                    :editor-options="{
                      visible: true,
                    }"
                  >
                    <DxLabel
                      :text="$t('useOtherReceiver')"
                      :visible="true"
                    />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem :col-count="3" :col-span="3">
                  <DxItem
                    data-field="observations"
                    editor-type="dxTextArea"
                    :editor-options="{ height: 50 }"
                    :col-span="3"
                  >
                    <DxLabel :text="$t('observations')" />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem :col-count="1" :col-span="1">
                  <DxItem
                    data-field="CodContacto"
                    editor-type="dxTextBox"
                    :editor-options="{
                      value: authenticatedUser.contacts[0].code,
                      disabled: true,
                      visible: false,
                    }"
                  >
                    <DxLabel
                      text="Codigo de contacto"
                      :visible="false"
                    />
                  </DxItem>
                </DxGroupItem>
              </DxForm>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxForm,
  DxItem,
  DxLabel,
  DxGroupItem,
} from 'devextreme-vue/form';
import { mapGetters, mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'MaterialRequester',
  components: {
    DxForm,
    DxItem,
    DxLabel,
    DxGroupItem,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      deliverytype: [
        { id: 1, label: this.$t('pickupAtAGQ') },
        { id: 2, label: this.$t('customerDelivery') },
      ],
      formData: {
        CodPresupuesto: null,
        deliveryType: null,
        Referencia: null,
        addresses: null,
        Email: null,
        contactCode: null,
        phone: null,
        observations: '',
        personaContacto: '',
        SelectContactCheck: false,
      },
      adressesDisabled: false,
      customStore: null,
      contactCode: null,
      ContactSelect: false,
    };
  },
  computed: {
    ...mapGetters('company', ['usersInfo']),
    ...mapGetters('contact', ['contactInfo']),
    ...mapState('user', ['authenticatedUser']),
    ...mapState('Offers', ['presupuestos']),
  },
  watch: {
    'formData.deliveryType': async function (TipoEntrega) {
      if (TipoEntrega === 1) {
        // this.adressesDisabled = true;
        this.formData.addresses = '';
      } else {
        this.adressesDisabled = false;
      }
    },
    'formData.SelectContactCheck': async function (show) {
      if (show === true) {
        this.ContactSelect = true;
        this.formData.contactCode = '';
        this.formData.Email = '';
      } else {
        this.ContactSelect = false;
        this.formData.contactCode = '';
        this.formData.Email = '';
      }
    },
    'formData.personaContacto': function (code) {
      const item = this.usersInfo?.find(
        (u) => u.contactCode === code
      );
      this.formData.contactCode = code ?? null;
      this.formData.Email = item?.email ?? null;
    },
    formData: {
      deep: true,
      handler() {
        this.emitFormData();
        // this.setContactCode();
      },
    },
  },
  async beforeMount() {
    try {
      await this.getUsers();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    }
    // } finally {
    //   this.formattedOffers();
    // }
  },
  methods: {
    // formattedOffers() {
    //   const presupuestos = this.store;
    //   this.customStore = presupuestos.sort(
    //     (a, b) =>
    //       new Date(b.FechaPresupuesto) - new Date(a.FechaPresupuesto)
    //   );
    //   console.log('componente formulario', this.customStore);
    //   return this.customStore;
    // },
    emitFormData() {
      const selectedUser = this.usersInfo.find(
        (user) => user.email === this.formData.Email
      );
      this.contactCode = selectedUser
        ? selectedUser.contactCode
        : null;
      this.formData.CodContacto = this.contactCode;
      this.$emit('updateFormData', this.formData);
    },
    setContactCode() {
      const selectedUser = this.usersInfo.find(
        (user) => user.email === this.formData.Email
      );
      this.contactCode = selectedUser
        ? selectedUser.contactCode
        : null;
      this.formData.CodContacto = this.contactCode;
    },
    ...mapActions('company', ['getUsers']),
  },
};
</script>
<style lang="scss">
@import './MaterialRequesterForm.styles.scss';
</style>
